import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { FormGroup, FormControl } from '@angular/forms';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { GlobalsService } from '../../../services/globals.service';
import { SharedPanelService } from '../../../../dms/layout/shared-panel/shared-panel.service';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { environment } from '../../../../../environments/environment';
import { Comunication } from '../../../interfaces/comunication';
import { GeneralGestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/servicios/general-gestion-tercerosService.Service';

@Component({
    selector: 'app-communications',
    templateUrl: './communications.component.html',
    styleUrls: ['./communications.component.scss']
})

@AutoUnsubscribe()
export class CommunicationsComponent implements OnInit {

    public formComunication: FormGroup;

    public selectorMensajes: Array<any>;
    @Input() formMode: boolean;
    @Input() modoEdicion: boolean;
    subjectCustomer: Subscription;
    error: string = "";
    isLoadingVehicles = false;
    customerId: string;
    items: any[];
    comunicaction: Comunication[] = [];
    public gridView: GridDataResult;
    public pageSize: number;
    public pageNumber: number;
    public skip: number;
    mensajeSeleccionado: string;
    dataTable: any[] = [
        {
            title: '',
            th: [
                'labels.tipo',
                'gestion_terceros.communication.codPlantilla',
                'labels.estado',
                'gestion_terceros.communication.fEnvio',
                'gestion_terceros.communication.mensaje'
            ],
            format: ['', '', '', '', ''],
            width: [],
            height: '280',
            fields: ['Type', 'TemplateCode', 'Status', 'SendDate', 'Text'],
            error: this.error
        }
    ];

    deshabilitarCampos: boolean;
    code: string;
    constructor(
        public _generalGestionTercerosService: GeneralGestionTercerosService,
        private _globals: GlobalsService,
        public _sharedPanelService: SharedPanelService,
        public _gestionTercerosService: GestionTercerosService
    ) {
        this.selectorMensajes = [
            { Code: 'ALL', Description: 'Todos' },
            { Code: 'EMAIL', Description: 'Email' },
            { Code: 'SMS', Description: 'Sms' },
        ];
        this.mensajeSeleccionado = 'ALL';
        this.skip = 0;
        this.pageNumber = 1;
        this.pageSize = 20;
    }
    ngOnInit() {
        if (this.formMode || !this.modoEdicion) {
            this.deshabilitarCampos = true;
        } else {
            this.deshabilitarCampos = false;
        }
        this.subjectCustomer = this._gestionTercerosService.observerActualCustomerCode().subscribe(val => {
            this.customerId = val;
        });

        this.getCommunication();
    }
    get f() { return this.formComunication.controls; }

    getCommunication() {
        this.formComunication = new FormGroup({
            Fecha1: new FormControl(this._globals.getThisweek('month', 'ini')),
            Fecha2: new FormControl(this._globals.getThisweek('month', 'fin')),
            Seleccionado: new FormControl(this.mensajeSeleccionado)
        });

        //aqui llamada al servicio que trae las comunicaciones
    }
    searchComunicaton() {
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/GetCustomerNotifications`;
        const datosFormulario = this.formComunication.getRawValue();
        const param = {
            dateFrom: this._globals.getDateFormatForServer(datosFormulario.Fecha1),
            dateTo: this._globals.getDateFormatForServer(datosFormulario.Fecha2),
            type: datosFormulario.Seleccionado,
            customerCode: this.customerId,
            pageInfo: {
                'Number': this.pageNumber,
                'Size': this.pageSize
            }
        };

        this._generalGestionTercerosService.getCustomerNotifications(_URL_, param).subscribe(data => {
            const auxdata = data.Response.Content;
            if (auxdata) {

                this.comunicaction = auxdata;

                this.comunicaction.forEach(d => {
                    d.SendDate = this._globals.getDateFormatMDY(d.SendDate);
                    // d.RepairData = this._globalService.getDateFormatMDY(d.RepairData);
                });

                this.dataTable[0]['gridView'] = {
                    data: this.comunicaction,
                    total: this.comunicaction.length
                };

            }
        });

    }


}

